module.exports = {
    triggerIdentifyEvent : (email) => {
        const hashedEmail = window.DYO.dyhash.sha256(email);
        const identifyEventData = {
            detail: {
                uid: hashedEmail,
                type: "he"
            }
        }
        document.body.dispatchEvent(new CustomEvent('dynamicYieldIdentify', identifyEventData));
    },
    triggerNewsletterSignup : (email) => {
        const hashedEmail = window.DYO.dyhash.sha256(email);
        const subscriptionEventData = {
            detail: {
                name: 'Newsletter Subscription',
                properties: {
                    dyType: 'newsletter-subscription-v1',
                    hashedEmail
                }
            }
        };
        
        const optinEvent = {
            detail: {
                name: 'message opt in',
                properties: {
                    dyType: 'message-optin-v1',
                    cuidType: 'email',
                    plainTextEmail: email
                }
            }
        };
        document.body.dispatchEvent(new CustomEvent('dynamicYieldEvent', subscriptionEventData));
        document.body.dispatchEvent(new CustomEvent('dynamicYieldEvent', optinEvent));
    },
    triggerSignUpEvent : (email) => {
        const hashedEmail = window.DYO.dyhash.sha256(email);
        const registerEventData = {
            detail: {
                name: 'Signup',
                properties: {
                    dyType: 'signup-v1',
                    hashedEmail
                }
            }
        };
        document.body.dispatchEvent(new CustomEvent('dynamicYieldEvent', registerEventData));
    }
}